import { Stack } from "@mui/material";
import { motion } from "framer-motion";
import { Outlet, useSearchParams } from "react-router-dom";
import Header from "../../components/UI/Menus/Header/Header";
import { useEffect } from "react";
import { tokenService } from "../../services/token.service";

const LinkAccessSchedulePage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) return;
    tokenService.saveAccessToken(token);
    searchParams.delete("token");
    setSearchParams(searchParams, { replace: true });
  }, [searchParams, setSearchParams]);

  return (
    <Stack width="100%">
      <Header hideHeaderRight />

      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.7, ease: [0.6, -0.05, 0.01, 0.99] }}
      >
        <Outlet />
      </motion.main>
    </Stack>
  );
};

export default LinkAccessSchedulePage;
